import './locale-select.scss';

import * as gzLocaleSelectDirective from './locale-select.directive';

export default angular.module('gazelle.components.localeSelect', [
  'rhino.components.locale',
  'pascalprecht.translate',
])
  .directive(gzLocaleSelectDirective.name, gzLocaleSelectDirective.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/locale-select/locale-select.module.js